











































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import SearchTree from "@/lib/Common/searchtree";
import CreateMessageConfig from "./createmessageconfig.vue";
import EditMessageConfig from "./editmessageconfig.vue";

class PageLogsRequest extends PageRequest {
  organizationId: number;
}

@Component({
  components: { CreateMessageConfig, EditMessageConfig },
})
export default class MessageConfig extends AbpBase {
  //filters
  pagerequest: PageLogsRequest = new PageLogsRequest();
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  searchName: string = "";
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  splitnum: number = 0.15;
  //修改
  edit() {
    this.editModalShow = true;
  }
  //新增
  create() {
    this.createModalShow = true;
  }
  //排序
  changeSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  //列表
  get list() {
    return this.$store.state.messageconfig.list;
  }
  get loading() {
    return this.$store.state.messageconfig.loading;
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.organizationId = item[0].id;
    }
    this.$store.commit("messageconfig/setCurrentPage", 1);
    this.getpage();
  }
  pageChange(page: number) {
    this.$store.commit("messageconfig/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("messageconfig/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "messageconfig/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.messageconfig.pageSize;
  }
  get totalCount() {
    return this.$store.state.messageconfig.totalCount;
  }
  get currentPage() {
    return this.$store.state.messageconfig.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 60,
      align: "left",
      title: this.L("IndexNo"),
      fixed: "left",
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 240,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title:
                  info.length > 0 ? info[0].displayName : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].displayName : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: this.L("Total"),
      key: "total",
      width: 130,
      sortable: true,
    },
    {
      title: this.L("BalanceUse"),
      key: "balanceTotal",
      sortable: true,
      width: 130,
    },
    {
      title: this.L("OccupyTotal"),
      key: "occupyTotal",
      sortable: true,
      width: 130,
    },
    {
      title: this.L("SendTotal"),
      key: "sendTotal",
      width: 130,
      sortable: true,
    },
    {
      title: this.L("MessageSendGroup"),
      key: "isGroup",
      width: 130,
      sortable: true,
       render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isGroup == true ? this.L("Started") : this.L("NoStart")
        );
      },
    },
    {
      title: this.L("ReceiveMobile"),
      key: "targetMobile",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.targetMobile,
            },
          },
          params.row.targetMobile
        );
      },
    },
    {
      title: this.L("ReceiveMail"),
      key: "targetMail",
      width: 130,
      sortable: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.targetMail,
            },
          },
          params.row.targetMail
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("messageconfig/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "messageconfig/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  ];
  async created() {
    await this.getItemDetail();
    this.getAreaTree();
    this.getpage();
  }
  async getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      let info = detaillist.filter((p) => {
        return p.itemId == 23;
      });
      info.forEach((ele) => {
        this.$data.smsPlatform.push({
          label: ele.name,
          value: ele.id,
        });
      });
    }
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    this.areaTree = SearchTree.searnchTree(value, treeList);
  }
  //区域
  async getAreaTree() {
    await this.$store
      .dispatch("organization/getCommanyItemTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  data() {
    return {
      smsPlatform: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
